/** @format */

const template = `
<div class="search-filter responsibility-info-filter">
  <ng-form name="filterSelectorForm" novalidate ng-model-options="{ updateOn: 'default' }">
    <div class="row">
      <div class="col-12">
        <search-employee
          employee="employee"
          employee-service="ctrl.employeeService"
          on-select="ctrl.toggleValue(personObj, filterSelectorForm); employee = null"></search-employee>
      </div>
    </div>
    <div ng-if="ctrl.helpText" class="row help-block">
      <div class="col-12">
        <p>{{::ctrl.helpText}}</p>
      </div>
    </div>
    <div class="row filter-preview-row">
      <div class="col-9">
        <div class="filter-preview-holder">
          <span class="filter-preview-title"> {{::ctrl.filterName|translate}} </span>
          <span class="filter-preview-content">
            <span ng-repeat="filterName in ctrl.getSelectionNames()" ng-class="{'item-separator': !$first}">{{::filterName}}</span>
          </span>
        </div>
      </div>
      <div class="col-3">
        <button
          type="submit"
          class="btn btn-lg btn-primary filter-submit"
          ng-click="ctrl.submitFilter()"
          ng-disabled="filterSelectorForm.$pristine"
          translate="SEARCH.FILTER_SELECTOR.OK">
        </button>
      </div>
    </div>
  </ng-form>
</div>
`;
export default template;
